import { Component, OnInit } from '@angular/core';
import {EmailServerConfig} from '../../data/emailServerConfig';
import {EmailingServiceService} from '../../services/emailing-service.service';
import {ElectronService} from 'ngx-electron';
import {SelectButtonModule} from 'primeng/selectbutton';

@Component({
  selector: 'app-email-settings',
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.scss']
})
export class EmailSettingsComponent implements OnInit {
  SMTPConfig: EmailServerConfig = new EmailServerConfig();
  IMAPConfig: EmailServerConfig = new EmailServerConfig();
  POP3Config: EmailServerConfig = new EmailServerConfig();
  isInitialized: boolean;

  receiveOptions: string[] = ['IMAP', 'POP3'];
  selectedOption: string = 'IMAP';

  constructor( private emailingService: EmailingServiceService,
               private electronService: ElectronService) { }

  async ngOnInit() {
    if ( await this.electronService.ipcRenderer.invoke('isInitialized')) {
      this.loadConfigs();
    }
  }

  async loadConfigs() {
    this.IMAPConfig = await this.emailingService.fetchIMAPConfig();
    this.SMTPConfig = await this.emailingService.fetchSMTPConfig();
    this.POP3Config = await this.emailingService.fetchPOP3Config();
  }

  async saveConfigs() {
    this.emailingService.saveSMTPConfig(this.SMTPConfig);

    if (this.selectedOption === 'IMAP') {
      this.emailingService.saveIMAPConfig(this.IMAPConfig);
    }
    else {
      this.emailingService.savePOP3Config(this.POP3Config);
    }

    this.electronService.ipcRenderer.invoke('initialize');
  }
}
